/* Flow service for using product offering */

import Helpers from "../helpers/shared.helper";
import Storage from "./storage.service";
import HTTP from "./http.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import Settings from "./settings.service";

import createHistory from "history/createBrowserHistory";
import Numbers from "./numbers.service";
const history = createHistory();

var Flow = {
  endCount: 0,
  vars: {
    root_id: null,
    root: null,
    uis_to_import: [],
    uis: null,
    decisions: null,
    steps: [],
    steps_by_id: {},
    steps_by_order: {},
    current: null,
    current_processing: null,
    flow_loaded: false,
    uis_by_path: {},
    nodes: null,
    temp: null,
  },
};

var obsrv = {};
var keys = Object.keys(Flow.vars);
for (let item of keys) {
  obsrv[item] = new BehaviorSubject(Flow.vars[item]);
}

Flow.get = function (setting) {
  return Flow.vars[setting];
};

Flow.get_obsrv = function (setting) {
  return obsrv[setting].asObservable();
};

Flow.set = (setting, val) => {
  Flow.vars[setting] = val;
  obsrv[setting].next(Flow.vars[setting]);
};

Flow.get_product = () => {
  return 92;
};

// Handle routing after -27 logout
Storage.get_obsrv("session").subscribe((data) => {
  Flow.endCount = 0;
  Flow.set("current", null);
});

Flow.getPOSettings = () => {
  // if (Settings.using_po_flow) {

  Flow.getBusinessFromPO();
  // } else {
  //   Flow.getStaticActiveFlow();
  // }
};

// Flow.getStaticActiveFlow = () => {
//   let static_data = {};
//   static_data["ui"] = [
//     {
//       id: "ui_login_1",
//       name: "ui_login",
//       next_id: "ui_payment_1"
//     },
//     {
//       id: "ui_payment_1",
//       name: "ui_payment",
//       next_id: "ui_thanks_1"
//     },
//     {
//       id: "ui_thanks_1",
//       name: "ui_thanks",
//       next_id: ""
//     }
//   ];
//   static_data["root_id"] = "ui_login_1";
//   static_data["steps"] = ["login", "payment", "thanks"];
//   Flow.set_vars(static_data);
// };

Flow.pathNumberOf = (node, callee = null) => {
  let steps_by_id = Flow.get("steps_by_id");
  if (steps_by_id[node.step_id]) {
    return steps_by_id[node.step_id]["order"];
  }
  return 0;
};

Flow.goWithDirection = (destination_node, callee = "def") => {
  // let going_forward = true;
  let current = Flow.get("current");

  if (!current) {
    let nodes = Flow.get("nodes");
    current = nodes[Flow.get("root_id")];
  }

  if (current) {
    let flow_status_order = Flow.pathNumberOf(current, "1");

    let destination_order = Flow.pathNumberOf(destination_node, "2");

    // let recommended = Flow.getRecommendedRoute(2);

    // let forbidden_key = Flow.steps["" + destination_order]["key"];
    // let forbidden_path = Flow.routes[forbidden_key]["path"];

    if (destination_order === flow_status_order) {
      if (current.web_mark_as_step_root) {
        Flow.goTo();
      } else {
        Flow.prev(1111);
      }

      // flow_status_order = Flow.pathSubOrderOf(current);
      // destination_order = Flow.pathSubOrderOf(destination_node);
    } else {
      if (destination_order < flow_status_order) {
        // console.log("Trying to go backward ..");

        if (destination_order > 1) {
          // this.setState({
          //   routeTo: isSub ? forbidden_path : Flow.prevRouteOf(forbidden_key)
          // });
          Flow.prev(1111);
        } else {
          // this.setState({
          //   routeTo: isSub ? forbidden_path : recommended
          // });
          Flow.next(22222);
        }
      } else {
        // console.log("Trying to go forward ..");
        Flow.next(33333);
        // this.setState({
        //   routeTo: isSub ? forbidden_path : recommended
        // });
      }
    }
  } else {
    // Flow.goTo();
    // Flow.goTo(Flow.get("root_id"));
  }
};

Flow.goToRoute = (loca) => {
  // console.log("found loca = ", loca);
  let destination_node = Flow.isRegisteredPath(loca);

  if (destination_node) {
    let allowed = Flow.isUIAllowed(destination_node.id);
    // console.log("allowed = " + destination_node.id + " = " + allowed);

    if (allowed) {
      // console.log("Go to ", destination_node);
      Flow.goTo(destination_node["id"], "", false);
    } else {
      Flow.goWithDirection(destination_node, "haaa");
    }
  }
};

if (Settings.enable_history) {
  // function goodbye(e) {
  //   if (!e) e = window.event;
  //   //e.cancelBubble is supported by IE - this will kill the bubbling process.
  //   e.cancelBubble = true;
  //   e.returnValue = 'You sure you want to leave?'; //This is displayed on the dialog

  //   //e.stopPropagation works in Firefox.
  //   if (e.stopPropagation) {
  //     e.stopPropagation();
  //     e.preventDefault();
  //   }
  // }
  // window.onbeforeunload = goodbye;
  // window.addEventListener('beforeunload', goodbye);
  history.listen((location, action) => {
    let new_location = location.hash.substring(2, location.hash.length); // new location
    let current = Flow.get("current");
    let old_location =
      current && current["web_pathname"] ? current["web_pathname"] : current;

    if (old_location !== new_location) {
      if (action === "PUSH") {

        // history.push({
        //   pathname: location.pathname + location.hash
        // });

        Flow.goToRoute(new_location);
      } else {
        // POP Back btn

        if( new_location === "activate-sim"){
          Storage.set("back_to_module", true);
        }

        if (new_location === "" && old_location !== null) {
          window.history.back();
          // window.location.assign(Settings.site_link)
        }

        if (new_location === "mnp" && old_location === "mnp-status") {
          Numbers.deleteAnyInitialReservations();
        } else if (new_location === "top_up" && old_location === "topup-pay") {
          Storage.clear("TopNumberAdded")
          window.location.reload()
        } else {
          Flow.goToRoute(new_location);
        }
      }
    }
  });
}

Flow.fetchBizPayment = () => {
	let config = {
		method: "get",
		url: "/biz_config/app",
	};
	return HTTP(config);
};

Flow.fetchBusinessConfig = () => {
  Storage.set("bizConfigLoading", true);
  let http_config = {
    method: "get",
    url: "/biz_config/app",
  };

  HTTP(http_config)
    .then((response) => {
      if (response.data) {
        let business = response.data;
        business["created_at"] = Date.parse(new Date());
        business["version"] = Settings["business_version"];

        Storage.set("business", JSON.stringify(business), true);
        Flow.getActiveFlowFromPO();
      } else {
        Helpers.log("Could not load business");
        throw new Error("failed_to_load_business_config");
      }
      Storage.set("bizConfigLoading", false);
    })
    .catch((error) => {
      Storage.set("bizConfigLoading", false);
    });
};

Flow.getBusinessFromPO = () => {
  let business = JSON.parse(Storage.get("business", true)) || {};

  if (business["created_at"]) {
    let y2k = Date.parse(new Date(business["created_at"]));
    let today = Date.parse(new Date());

    if (
      Helpers.dateDiff("n", y2k, today) + 1 >
      Settings["data_expiry_duration"] ||
      Settings["business_version"] !== business["version"]
    ) {
      Flow.fetchBusinessConfig();
    } else {
      Flow.getActiveFlowFromPO();
    }
  } else {
    Flow.fetchBusinessConfig();
  }
};

Flow.fetchingGraph = () => {
  Storage.set("graphLoading", true);
  let http_config = {
    method: "get",
    url: "/graphs/signup?graph_id=" + Settings.graph_id,
  };

  HTTP(http_config)
    .then((response) => {
      if (response.data) {
        let graph;
        graph = response.data;
        graph["created_at"] = Date.parse(new Date());
        graph["version"] = Settings["graph_version"];
        if (Settings.cache_graph) {
          Storage.set("graph", JSON.stringify(graph), true);
        } else {
          Storage.set("graph", JSON.stringify(graph));
        }

        Flow.set_vars(response.data);
      } else {
        Helpers.log("Could not load business");
        throw new Error("failed_to_load_flow");
      }
      Storage.set("graphLoading", false);
    })
    .catch((error) => {
      Storage.set("graphLoading", false);
     });
};

Flow.getActiveFlowFromPO = () => {
  let graph = JSON.parse(Storage.get("graph", true)) || {};
  if (graph["created_at"]) {
    let y2k = Date.parse(new Date(graph["created_at"]));
    let today = Date.parse(new Date());

    if (
      Helpers.dateDiff("n", y2k, today) + 1 >
      Settings["data_expiry_duration"] ||
      graph["version"] !== Settings["graph_version"]
    ) {
      Flow.fetchingGraph();
    } else {
      window.setTimeout(() => {
        Flow.set_vars(graph);
      }, 100);
    }
  } else {
    Flow.fetchingGraph();
  }
};

let uis = {};
let decisions = {};
let nodes = {};
let steps_by_id = {};
let steps_by_order = {};

Flow.set_vars = (source) => {
  for (let step of source.steps) {
    step["root_node"] = false;
    steps_by_id[step["id"]] = step;
  }

  for (let ui of source.ui) {
    uis[ui.id] = ui;
    nodes[ui.id] = ui;

    if (ui["web_mark_as_step_root"]) {
      steps_by_id[ui.step_id]["root_node"] = ui;
      steps_by_id[ui.step_id]["step_flag"] = ui["resume_skip_flag"];
    }
  }

  if (source.decisions) {
    for (let decision of source.decisions) {
      decisions[decision.id] = decision;
      nodes[decision.id] = decision;
    }
  }

  if (source.get_product && source.get_product.id) {
    nodes[source.get_product.id] = {};

    for (let product of source.get_product.ids) {
      nodes[source.get_product.id][product.product_id] = product;
    }

    nodes[source.get_product.id]["name"] = "get_product";
  }

  Flow.set("uis", uis);
  Flow.set("decisions", decisions);
  Flow.set("nodes", nodes);

  let uis_by_path = {};

  // UI components to import in app.js
  let uis_to_import = source.ui.map((ui) => {
    let path = ui.web_pathname ? ui.web_pathname : ui.name;
    uis_by_path[path] = ui;
    return {
      name: ui.name,
      path: path,
    };
  });

  Flow.set("uis_by_path", uis_by_path);

  Flow.set("uis_to_import", uis_to_import);

  Flow.set("root_id", source.root_id);
  Flow.set("current_processing", nodes[source.root_id]);

  for (let stepIndex in source.steps) {
    let id = source.steps[stepIndex]["id"];
    steps_by_id[id]["order"] = parseInt(stepIndex);
    let step = steps_by_id[id];
    source.steps[stepIndex] = step;
    steps_by_order["" + step["order"]] = step;
  }

  Flow.set("steps_by_id", steps_by_id);
  Flow.set("steps_by_order", steps_by_order);

  Flow.set("steps", source.steps);

  Flow.set("flow_loaded", true);
};

Flow.skipToEnd = () => {
  //@Todo skip to end
};

Flow.next = (callee = null) => {
  // console.log("go to next.. callee = " + callee);
  let next = Flow.vars.current_processing.next_id;
  if (next) {
    Flow.goTo(next);
  } else {
    Flow.goTo(Flow.get("root_id"));
  }
};

Flow.prev = (callee = null) => {
  // console.log("go to prev.. callee = " + callee);
  Flow.goBack();
};

Flow.reachedEnd = () => {
  console.log("reachedEnd");
  // "reached end.. go to root");
  // User.logout();
  Flow.endCount = Flow.endCount + 1;
  if (Flow.endCount < 3) {
    Flow.goTo(Flow.get("root_id"));
  } else {
    console.log("End");
  }
};

Flow.goToLast = () => {
  let nodes = Flow.vars.nodes;
  let nodes_ids = Object.keys(nodes);
  Flow.goTo(nodes_ids[nodes_ids.length - 1]);
};

Flow.goBack = (current_id = null) => {
  let current = null;

  if (current_id) {
    let nodes = Flow.get("nodes");
    current = nodes[current_id];
  } else {
    current_id = Flow.get("current")["id"];
  }

  if (!current) {
    current = Flow.get("current");
  }

  Helpers.log("Going back from " + current_id);

  let steps_by_id = Flow.get("steps_by_id");
  let steps_by_order = Flow.get("steps_by_order");

  if (typeof current === "string") {
    Flow.goTo(Flow.get("root_id"));
  } else {
    let current_step = steps_by_id[current.step_id];

    let previous_step_order = current_step.order - 1;
    previous_step_order = previous_step_order < 1 ? 1 : previous_step_order;

    let previous_step = steps_by_order["" + previous_step_order];

    let node_to = previous_step["root_node"]["id"];

    if (Flow.isUIAllowed(node_to, "5")) {
      Flow.goTo(previous_step["root_node"]["id"], "", false);
    } else {
      Flow.goBack(node_to);
    }
  }
};

Flow.isRegisteredPath = (route) => {
  let paths = Flow.get("uis_by_path");
  return paths[route] || Helpers.exceptionParamsExist();
};

Flow.findNextRouteAndGo = (callee = null) => {
  let route = Helpers.getURLPieces();
  let current = Flow.get("current");

  if (route["base"] && Flow.isRegisteredPath(route["base"])) {
    let uis_by_path = Flow.get("uis_by_path");
    let node = uis_by_path[route["base"]];

    let allowed = true;
    if (node) {
      allowed = Flow.isUIAllowed(node.id, "3");
    }

    if (allowed) {
      let pathname =
        current && current["web_pathname"] ? current["web_pathname"] : current;

      if (node) {
        if (node["web_pathname"] !== route["base"]) {
          Flow.endCount = 0;
          Flow.set("current", node);
        } else {
          Flow.next(6);
        }
      } else {
        if (route["base"] !== pathname) {
          Flow.endCount = 0;
          Flow.set(
            "current",
            route["params"]
              ? route["base"] + "?" + route["params"]
              : route["base"]
          );
        } else {
          // Flow.goTo(Flow.get("root_id"));
          Flow.next(7344433);
        }
      }
    } else {
      Flow.next(7);
    }
  } else {
    // Flow.goTo(Flow.get("root_id"));
    Flow.next(7333);
  }
};

// Flow.setCurrentFromPath = path => {
//   if (Flow.isRegisteredPath(path) && Flow.isUIAllowed(path)) {
//     let uis_by_path = Flow.get("uis_by_path");
//     let node = uis_by_path[path];
//     if (node) {
//       Flow.set("current", node);
//       // let steps = Flow.get("steps_by_id");
//       // for(let stepKey of Object.keys(steps)){
//       //   let step = steps[stepKey];
//       // }
//     }
//   }
// };

Flow.evaluateFlag = (flag) => {
  let flags = Storage.get("flags");
  let available_flags = flags ? Object.keys(flags) : [];
  let flag_result = false;
  let condition = true;

  if (flag[0] === "!") {
    flag = flag.substring(1);
    condition = false;
  }

  if (available_flags.indexOf(flag) !== -1) {
    flag_result = flags[flag];
  } else {
    if (Storage.get(flag)) {
      flag_result = true;
    } else {
      if (Storage.get(flag, true)) {
        let vv = Storage.get(flag, true);
        // if parsable
        if (Helpers.jsonParsable(vv)) {
          flag_result = JSON.parse(vv);
        } else {
          flag_result = true;
        }
      }
    }
  }

  if (flag === "order_id") {
    flag_result = Storage.get(flag, true) ? true : false;
  }

  if(!flags && flag === "CanSearch"){
    flag_result = true;
  }

  flag_result = !!flag_result;  

  return flag_result === condition;
};

Flow.isUIAllowed = (node_id, callee = "Flow.isUIAllowed callee") => {

  let allowed = true;
  if (Flow.vars.uis) {
    let node = Flow.vars.uis[node_id];

    if (node) {
      let required_flags = node["web_required_flags"];
      if (required_flags) {
        required_flags = required_flags.replace(/ /g, "");
        required_flags = required_flags.split(",");
        for (let flag of required_flags) {
          if (flag) {
            let flag_result = Flow.evaluateFlag(flag);
            if (!flag_result) {
              allowed = false;
              break;
            }
          }
        }
      }
    }
  }
  return allowed;
};

Flow.goTo = (nodeIdentifier = null, params = "", goingForward = true) => {

  Storage.set("error", null);
  let flags = Storage.get("flags");
  Helpers.log("Current Flow Status", flags);

  let available_flags = flags ? Object.keys(flags) : [];

  if (nodeIdentifier) {
    if (Flow.vars.nodes[nodeIdentifier]) {

      let node_id = nodeIdentifier;

      if (Flow.vars.nodes[node_id].falsy && Flow.vars.nodes[node_id].truthy) {
        let flag = Flow.vars.nodes[node_id]["check_flag"];

        let condition = true;
        if (flag[0] === "!") {
          flag = flag.substring(1);
          condition = false;
        }

        let decision =
          available_flags.indexOf(flag) !== -1
            ? flags[flag]
            : Storage.get(flag, true);

        if (typeof decision === "string") {
          decision = JSON.parse(decision);
        }

        if (decision === condition) {
          Flow.goTo(Flow.vars.nodes[node_id].truthy);
        } else {
          Flow.goTo(Flow.vars.nodes[node_id].falsy);
        }
      } else {
        if (Flow.vars.uis[node_id]) {
          Flow.set("current_processing", Flow.vars.nodes[node_id]);
          // let same_route = false;

          // if(Flow.get("current") && node_id === Flow.get("current")['id']){
          //   same_route = true;
          // }

          if (Flow.isUIAllowed(node_id, "2")) {
            // console.log("allowed " + node_id);
            let skip_it = false;
            if (goingForward) {
              let skipping_flags = Flow.vars.nodes[node_id]["resume_skip_flag"];

              // const skipFlagResult = Flow.parseAndEvaluateFlags(skipping_flag);

              let skipFlagResult = false;

              if (skipping_flags) {
                skipping_flags = skipping_flags.replace(/ /g, "");
                skipping_flags = skipping_flags.split(",");
                for (let flag of skipping_flags) {
                  if (flag) {
                    let flag_result = Flow.evaluateFlag(flag);
                    if (flag_result) {
                      skipFlagResult = true;
                      break;
                    }
                  }
                }
              }

              // console.log("skipping_flag", skipping_flag);
              if (skipping_flags && flags && skipFlagResult === true) {
                skip_it = true;
              } else {
                if (
                  Flow.vars.nodes[node_id]["web_mobile_only"] &&
                  !Helpers.isMobile()
                ) {
                  skip_it = true;
                }
              }
            }

            // console.log('skip_it===>', skip_it)
            // console.log('node_id===>', node_id)


            if (skip_it) {
              if (goingForward) {
                Flow.next(8);
              } else {
                Flow.goBack(Flow.vars.nodes[node_id]["id"]);
              }
            } else {
              let current = Flow.get("current");
              let to_node = Flow.vars.nodes[node_id];

              // console.log(to_node);

              if (current) {
                if (current.id !== to_node.id) {
                  Flow.endCount = 0;
                  Flow.set("current", to_node);
                } else {
                  // console.log("Avoided refresh");
                  // Flow.set("current", to_node);
                }
              } else {
                Flow.endCount = 0;
                Flow.set("current", to_node);
              }
            }
          } else {
            // console.log("not allowed", node_id);
            // Flow.goWithDirection(Flow.vars.uis[node_id], "ddddddaaaaaaas");
            // Flow.next(5);
            Flow.findNextRouteAndGo(112121);
          }
        } else {
          if (Flow.vars.nodes[node_id].name === "get_product") {
            let val = Flow.get_product();
            Helpers.log("product id is " + val);
            let next = Flow.vars.nodes[node_id][val]["next_id"];
            Flow.goTo(next);
          } else {
            // other types of nodes
          }
        }
      }
    } else {
      if (Flow.isRegisteredPath()) {
        Flow.findNextRouteAndGo(1);
      } else {
        Flow.reachedEnd();
      }
    }

  } else {

    if (Flow.isRegisteredPath()) {
      Flow.findNextRouteAndGo(2);
    } else {
      Flow.reachedEnd();
    }
  }
};

Flow.parseAndEvaluateFlags = function (flagsStr, defaultResult = false) {
  const storedFlags = Storage.get("flags", true);
  const flags = flagsStr.split(",");

  let finalResult = null;

  flags.forEach((flag) => {
    let negaitveCondition = false;

    if (flag[0] === "!") {
      flag = flag.substring(1);
      negaitveCondition = true;
    }
    const value =
      typeof storedFlags[flag] !== "undefined"
        ? storedFlags[flag]
        : Storage.get(flag, true) ? JSON.parse(Storage.get(flag, true)) : null;

    const flagResult = negaitveCondition ? !Boolean(value) : Boolean(value);

    if (finalResult === null) {
      finalResult = flagResult;
    } else {
      finalResult = finalResult && flagResult;
    }
  });

  Helpers.log("flagsStr", finalResult);
  return finalResult;
};

export default Flow;
